import Logger from './logger';

/**
 * Tracker for updated Layouts
 *
 * @constructor
 */
export default class LayoutUpdateTracker {
    constructor(storageKey = 'ofcsUpdatedLayouts') {
        try {
            this.localStorage = window.localStorage;
        } catch (e) {
            Logger.warn('LocalStorage is disabled');
        }
        this.storageKey = storageKey;
    }

    /**
     * @private
     * @return {*}
     */
    getStorageValue() {
        return this.localStorage.getItem(this.storageKey);
    }

    /**
     * @private
     * @param {*} value
     * @return {LayoutUpdateTracker}
     */
    setStorageValue(value) {
        this.localStorage.setItem(this.storageKey, value);

        return this;
    }

    /**
     * Add updated layout
     *
     * @param {string} layoutId Layout ID
     * @return {LayoutUpdateTracker}
     */
    addUpdatedLayout(layoutId) {
        if (!this.isAvailable() || !layoutId) {
            return this;
        }

        const updatedLayouts = this.getUpdatedLayouts();

        updatedLayouts[layoutId] = {
            id: layoutId,
            timestamp: new Date().getTime(),
        };

        try {
            this.setStorageValue(JSON.stringify(updatedLayouts));
        } catch (e) {
            return this;
        }

        return this;
    }

    /**
     * Return updated layouts
     *
     * @return {Object}
     */
    getUpdatedLayouts() {
        if (!this.isAvailable()) {
            return null;
        }

        const updatedLayoutsJson = this.getStorageValue();

        if (updatedLayoutsJson) {
            try {
                return JSON.parse(updatedLayoutsJson);
            } catch (e) {
                return {};
            }
        }

        return {};
    }

    /**
     * Are updates available?
     *
     * @return {boolean}
     */
    hasUpdatedLayouts() {
        if (!this.isAvailable()) {
            return false;
        }

        const updatedLayouts = this.getUpdatedLayouts();

        return Object.values(updatedLayouts).length > 0;
    }

    /**
     * Remove all updated
     *
     * @return {LayoutUpdateTracker}
     */
    clear() {
        if (!this.isAvailable()) {
            return this;
        }

        this.localStorage.removeItem(this.storageKey);

        return this;
    }

    /**
     * Is the tracker available?
     *
     * @return {boolean}
     */
    isAvailable() {
        return !!this.localStorage;
    }
}
